import { Content } from '@prismicio/client';
import {
  HEADING_LINK_TYPE_WITHOUT_PATH,
  NavigationHeading,
} from '../NavigationHeading/NavigationHeading';
import { ListItem } from '../ListItem/ListItem';

import styles from './footerMenu.module.scss';

export const FooterMenu = ({ slice }: { slice: Content.NavigationSlice }) => {
  const { variation } = slice;
  const listStyle = styles[variation];

  const { heading, link, drop_down_links } = slice.primary;

  const stylesWithoutPath =
    link.link_type !== HEADING_LINK_TYPE_WITHOUT_PATH
      ? ''
      : styles.heading_without_path;

  const headingStyles = `${listStyle} ${styles.heading} ${stylesWithoutPath}`;
  const listItemStyles = {
    link: `${listStyle} ${styles.link} ${styles.link_animation}`,
    text: `${listStyle} ${styles.text}`,
    item: styles.item,
  };

  return (
    <div className={`${listStyle} ${styles.container}`}>
      {heading && (
        <NavigationHeading
          heading={heading}
          link={link}
          footerStyles={headingStyles}
        />
      )}
      <ul className={`${listStyle} ${styles.list}`}>
        {drop_down_links.map((item, index) => {
          const hasScrollToSection = 'scroll_to_section_number' in item;

          return (
            <ListItem
              scrollToSectionNumber={
                hasScrollToSection ? item.scroll_to_section_number : null
              }
              key={`${item.title} ${index}`}
              link={item.link}
              title={item.title}
              footerStyles={listItemStyles}
              type={'linktype' in item ? (item.linktype as string) : null}
            />
          );
        })}
      </ul>
    </div>
  );
};
